module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": '/clients/' + _vm.currentClientId + '/reports'
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Client")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.varHelpVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Variable Reference\n\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.pdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pdf-o"
  }), _vm._v(" Report PDF\n\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.pdfCoverUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pdf-o"
  }), _vm._v(" Report PDF - Cover\n\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.docUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-word-o"
  }), _vm._v(" Report to Word\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Report Title",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_title),
      expression: "report.report_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.report_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.report.report_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Report Issue Date",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    attrs: {
      "extra-classes": "form-control"
    },
    model: {
      value: (_vm.report.date_issued),
      callback: function($$v) {
        _vm.report.date_issued = $$v
      },
      expression: "report.date_issued"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Location",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.location_id),
      expression: "report.location_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.report.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchAudits]
    }
  }, _vm._l((_vm.locations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v("Report Sections")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-stacked report-sections"
  }, _vm._l((_vm.sections), function(section) {
    return _c('li', {
      class: {
        active: _vm.activeSection == section.id
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.activeSection = section.id
        }
      }
    }, [_vm._v(_vm._s(section.heading))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, _vm._l((_vm.sections), function(section) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeSection == section.id),
        expression: "activeSection == section.id"
      }],
      staticClass: "section-editor"
    }, [_c('button', {
      staticClass: "btn btn-primary pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.importPrompt(section)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Import Audit Data Into Findings")]), _vm._v(" "), _c('h2', [_c('small', [_vm._v("Findings:")]), _vm._v(" " + _vm._s(section.heading))]), _vm._v(" "), _c('image-upload-field', {
      attrs: {
        "api-base": _vm.apiBase,
        "multi": true,
        "upload-msg": "Upload section images here",
        "images": section.images,
        "upload-type": "audit-image"
      },
      on: {
        "imageListChanged": function($event) {
          _vm.saveImageFieldChange($event, section)
        }
      }
    }), _vm._v(" "), _c('rich-text', {
      key: section.id,
      attrs: {
        "id": 'editor-' + section.id
      },
      on: {
        "input": _vm.editorChanged
      },
      model: {
        value: (section.findings),
        callback: function($$v) {
          section.findings = $$v
        },
        expression: "section.findings"
      }
    })], 1)
  }))])]), _vm._v(" "), (_vm.varHelpVisible) ? _c('variable-help', {
    attrs: {
      "modal-visible": _vm.varHelpVisible
    },
    on: {
      "close": function($event) {
        _vm.varHelpVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.importModal.visible) ? _c('modal-dialog', {
    attrs: {
      "modal-visible": _vm.importModal.visible,
      "title": "Audit Import",
      "confirm-button-text": "Import",
      "button-class": "btn-primary"
    },
    on: {
      "confirm": function($event) {
        _vm.importAuditData(_vm.importModal.section)
      },
      "closeModal": function($event) {
        _vm.importModal.visible = false
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Audits to Import From",
      "col-class": "col-md-4"
    }
  }, [(_vm.auditsLoading) ? _c('p', {
    staticClass: "form-control-static"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includedAudits),
      expression: "includedAudits"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.includedAudits = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.audits), function(audit) {
    return _c('option', {
      domProps: {
        "value": audit.id
      }
    }, [_vm._v(_vm._s(audit.audit_date) + " " + _vm._s(audit.form_templates.form_name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includePositiveFindings),
      expression: "includePositiveFindings"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includePositiveFindings) ? _vm._i(_vm.includePositiveFindings, null) > -1 : (_vm.includePositiveFindings)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.includePositiveFindings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includePositiveFindings = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.includePositiveFindings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includePositiveFindings = $$c
        }
      }
    }
  }), _vm._v("\n\t\t\t\tImport Positive as well as negative findings\n\t\t\t")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc08ea6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportEditor.vue
// module id = 297
// module chunks = 0